import { drawImage } from './images.js'
import { GetScene } from './sceneController.js'

let maxFrame = 7
let frame = maxFrame
let animationSpeed = 0.2
let scene = null

function Reset() {
    frame = maxFrame
    scene = null
}

function frameRect() {
    return { x: parseInt(frame) * 64, y: 0, w: 64, h: 64 }
}

function AnimationFrame(delta) {
    if (!scene) {
        scene = GetScene('transition-clouds-out')
    }
    if (scene.onUpdate) {
        scene.onUpdate({
            frame: frame, maxFrame: maxFrame
        })
    }

    drawImage('transition-clouds', 0, 0, frameRect())

    if (frame > 0) {
        frame -= delta * animationSpeed
    }
    frame = frame < 0 ? 0 : frame
}

export { AnimationFrame, Reset }